// Показ истории: метка источника, длительность, разбивка по дням.
//
// Отдельно от экрана, потому что это арифметика, а её в этом проекте держат
// под тестом. Группировка по дням особенно: она опирается на то, что журнал
// уже отсортирован, и молча склеила бы два разных дня, если однажды перестанет.

import type { AttemptSource, HistoryRow } from "../contract";

/** Метка источника. У набора дня её нет: это норма, а не особый случай. */
export const SOURCE_LABEL: Record<AttemptSource, string | null> = {
  today: null,
  diagnostic: "диагностика",
  control: "контроль",
  testout: "зачёт",
  drill: "тренажёр",
};

/**
 * «45 с», «2:05». `null` — времени нет.
 *
 * Ноль не показывается вовсе: диагностика и контролёры время не измеряют, там
 * в журнале честный ноль, и «0 с» читалось бы как решено мгновенно.
 */
export function duration(ms: number): string | null {
  if (ms <= 0) return null;
  const total = Math.round(ms / 1000);
  if (total < 60) return `${total} с`;
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
}

export interface HistoryDay {
  date: string;
  rows: HistoryRow[];
}

/**
 * Строки одного дня — подряд, в порядке журнала.
 *
 * Не сортирует и не должна: журнал приходит от новых к старым, и любая
 * пересортировка здесь означала бы, что порядок задаётся в двух местах.
 * Группируются только СОСЕДНИЕ строки — если один и тот же день придёт двумя
 * кусками, это два заголовка, и это правда о данных, а не дефект показа.
 */
export function byDay(rows: HistoryRow[]): HistoryDay[] {
  const days: HistoryDay[] = [];
  for (const row of rows) {
    const last = days[days.length - 1];
    if (last !== undefined && last.date === row.date) last.rows.push(row);
    else days.push({ date: row.date, rows: [row] });
  }
  return days;
}

/** Ключ строки: по одной задаче попыток бывает несколько, ключа задачи мало. */
export function rowId(row: HistoryRow): string {
  return `${row.itemKey}:${row.at}`;
}
